export const FEATURES = {
  isSimilarRequirementsEnabled: true,
  isMetricDrillDownEnabled: true
};
